import { POST_FOUNDERS_START } from '../../types';

export const post_founders = (payload) => ({
  type: POST_FOUNDERS_START,
  payload,
});
